App.factory('userFactory', userFactory);

userFactory.$inject = [
    'DispatcherService'
];

function userFactory(DispatcherService) {
    return {
        query: function() {
            return DispatcherService.get('users');
        },

        find: function(user_id) {
            return DispatcherService.get('users/' + user_id);
        },

        create: function(user) {
            return DispatcherService.post('users', user);
        },

        update: function(user) {
            return DispatcherService.put('users/' + user.id, user);
        },

        destroy: function(user_id) {
            return DispatcherService.delete('users/' + user_id);
        }
    }
}